export const availableLanguages = ['hu', 'en'] as const
export type AvailableLanguageType = typeof availableLanguages[number]

export const currentLang = (): AvailableLanguageType | undefined => {
  const firstQuestionMarkIndex = window.location.href.indexOf('?')
  if (firstQuestionMarkIndex === -1) {
    return undefined
  }
  const langValue =
    new URLSearchParams(
      window.location.href.substring(firstQuestionMarkIndex),
    ).get('lang') ?? undefined

  if (availableLanguages.find(item => item === langValue) === undefined) {
    return undefined
  }
  return langValue as AvailableLanguageType
}
